import { all, fork } from 'redux-saga/effects'
import {
  getProgramsFlow,
  getAllStatesFlow,
  createProgramsFlow,
  getSystemsFlow,
  postProgramFilesWatcher,
  getProgramEnrollmentMetadataOfProgramWatcher,
  deleteProgramFileWatcher,
  downloadProgramFileWatcher,
  getProgramById
} from './Programs'
import {
  signUpWithDetails,
  signInWithDetails,
  passwordChange,
  signOutUser,
  getCurrentUser,
} from './Auth'

export default function* root() {
  yield all([
    fork(getProgramsFlow),
    fork(getSystemsFlow),
    fork(signUpWithDetails),
    fork(signInWithDetails),
    fork(getAllStatesFlow),
    fork(postProgramFilesWatcher),
    fork(passwordChange),
    fork(signOutUser),
    fork(getCurrentUser),
    fork(getProgramEnrollmentMetadataOfProgramWatcher),
    fork(deleteProgramFileWatcher),
    fork(downloadProgramFileWatcher),
    fork(getProgramById)
  ])
}
